import groupBy from "lodash/groupBy";
import resolve from "ng";
import $appConfig from "servicestack/config";
import eventListener from "servicestack/event-listener";
import gtm from "servicestack/service-bus.gtm";
import uploadTransform from "servicestack/upload-transform";
import httpCodes from "webutils/http-codes";
import { serializeQueryString, uuid } from "webutils/services/util";

let allCalls = 0;
const DEFAULT_REQUEST = {};
const DEFAULT_HEADERS = {
  Pragma: undefined,
  "Cache-Control": undefined,
  "X-Instance-StartedAt": new Date().toISOString(),
  "X-Instance-StartedEpoch": new Date().getTime(),
  "X-Instance-Id": uuid(),
  "X-Requested-With": undefined,
  "If-Modified-Since": undefined,
};

export default class ServiceBus {
  static send(route, _request, _config) {
    return new ServiceBus().send(route, _request, _config);
  }
  static getUrl(route, request, ext) {
    const $rootScope = resolve("$rootScope");
    const $cart = $rootScope.$cart || {};
    const req = Object.assign(
      {
        "X-sse-subscription": eventListener.options.id,
        "X-cart-id": $cart.id,
      },
      DEFAULT_HEADERS,
      request,
      $appConfig.sessionId
        ? {
            "X-ss-pid": $appConfig.sessionId,
            "X-ss-opt": "perm",
          }
        : {}
    );
    // let url = $appConfig.serviceUrl + route.replace(".json", ext);
    // url += route.indexOf("?") > 0 ? "&" : "?";
    // url += serialize(req);
    let url = $appConfig.resolveServiceUrl(route.replace(".json", ext));
    url += route.indexOf("?") > 0 ? "&" : "?";
    url += serializeQueryString(request);
    return url;
  }
  static read(route, _request, _config) {
    return new ServiceBus().send(route, _request, _config);
  }
  static upload(route, _request, _config) {
    return new ServiceBus().upload(route, _request, _config);
  }

  constructor() {
    const bus = this;
    bus.activeCalls = [];
    bus.failedCalls = [];
    bus.validationErrors = {};
    bus.serverError = {};
    bus.calls = 0;
    bus.uploading = false;
  }

  send(route, _request, _config) {
    // console.warn("ServiceBus.send", { route, _request, _config, $appConfig });
    const $q = resolve("$q");
    const $http = resolve("$http");
    const $rootScope = resolve("$rootScope");
    const $cart = $rootScope.$cart || {};
    const deferred = $q.defer();
    const bus = this;
    const request = Object.assign({}, DEFAULT_REQUEST, _request);
    const headers = Object.assign(
      {
        // "Referer-Policy": "no-referrer-when-downgrade",
        "X-emun-referrer": location.href,
        "X-sse-subscription": eventListener.options.id,
        "X-cart-id": $cart.id,
      },
      DEFAULT_HEADERS,
      $appConfig.sessionId
        ? {
            "X-ss-pid": $appConfig.sessionId,
            "X-ss-opt": "perm",
          }
        : {}
    );
    delete request.$$hashkey;
    const config = Object.assign(
      {
        url: $appConfig.resolveServiceUrl(route),
        method: "POST",
        data: request,
        eventHandlers: {
          progress(c) {
            deferred.notify(c);
            //console.info('Progress -> ' + c);
            //console.log(c);
          },
        },
        uploadEventHandlers: {
          progress(e) {
            deferred.notify(e);
            //console.info('UploadProgress -> ' + e);
            //console.log(e);
          },
        },
        withCredentials: true, // !$appConfig.plugin,
        params: {},
        headers,
      },
      _config
    );

    if (config.method === "GET") Object.assign(config.params, request);
    for (const pn in config.params) {
      if (Array.isArray(config.params[pn]) && config.params[pn].length) {
        config.params[pn] = config.params[pn].join(",");
      }
    }
    bus.validationErrors = null;
    bus.serverError = null;
    if (location.href.startsWith("ss:")) {
      // console.info("ServiceBus.send", { route, headers, config, $appConfig });
      // console.info("ServiceBus.send.route", route);
      // console.info("ServiceBus.send.headers", headers);
      // console.info("ServiceBus.send.config", config);
      // console.info("ServiceBus.send.$appConfig", $appConfig);
      if (config.method === "POST") {
        Object.assign(headers, {
          "X-ss-payload": JSON.stringify(request || {}),
        });
      }
    }
    const call = $http(config);
    call.route = route;
    call.id = bus.calls++;
    call.$id = allCalls++;
    call.timestamp = new Date();
    call.config = config;
    call.referrer = location.href;
    call.cancel = () =>
      console.warn("canceled", call, deferred.reject("canceled"));
    bus.activeCalls.push(call);

    call.then(deferred.resolve, deferred.reject, deferred.notify);

    call.then(
      (response) => {
        call.response = response;
        call.success = true;
        if (location.href.startsWith("ss:")) {
          console.debug("ServiceBus.response", route, response);
        }
      },
      (response) => {
        call.response = response;
        call.success = false;
        bus.failedCalls.push(call);
        console.warn("ServiceBus.error", response);
        switch (response.status) {
          case httpCodes.BAD_REQUEST:
          case httpCodes.UNAUTHORIZED:
          case httpCodes.FORBIDDEN:
            if (response.data && response.data.responseStatus) {
              if (
                response.data.responseStatus.errors &&
                response.data.responseStatus.errors.length
              ) {
                bus.validationErrors = groupBy(
                  response.data.responseStatus.errors,
                  "fieldName"
                );
              } else {
                bus.validationErrors = { all: [response.data.responseStatus] };
              }
              bus.validationErrors.$route = route;
            }
            console.info(
              "ServiceBus.validationErrors",
              bus.validationErrors,
              config.url
            );
            if (
              response.status !== httpCodes.BAD_REQUEST &&
              config.url.indexOf("/auth/") === -1
            ) {
              $rootScope.$emit("servicestack.unauthorized", response);
              //modals.alert("You are not authorized to perform this operation.", "Insufficient Privileges");
            }
            //notify.error(data);
            break;
          case httpCodes.INTERNAL_SERVER_ERROR:
          default:
            bus.serverError = response.data;
            console.error("servicestack.server-error", response);
            $rootScope.$emit("servicestack.server-error", response);
            console.error("ServiceBus.catchAll", response);
            //modals.alert(data.responseStatus.message, 'Internal Server Error');
            //notify.error(data.responseStatus.message);
            break;
        }
      },
      (e, x, y, z) => {
        deferred.notify(e, x, y, z);
        //console.info('progressEvent', progressEvent);
        console.warn("$http.notify", e, x, y, z);
      }
    );

    call.finally(() => {
      const startedAt = call.timestamp.getTime();
      const finishedAt = new Date().getTime();
      Object.assign(call, {
        // bus,
        startedAt,
        finishedAt,
        duration: finishedAt - startedAt,
      });
      // console.warn('gtm.finally', { route, call, config, bus });
      try {
        gtm(call);
      } catch (ee) {
        console.error("gtm.finally", { ee, route, call, config, bus });
      }
      bus.activeCalls = bus.activeCalls.filter((ac) => ac !== call);
    });

    return deferred.promise; //call
  }

  cancelAll() {
    return this.activeCalls.forEach((c) => c.cancel());
  }

  subscriptionId() {
    return eventListener.options.id;
  }

  read(route, request, _config) {
    return this.send(
      route,
      request,
      Object.assign({}, _config, { method: "GET" })
    );
  }

  upload(route, request, _config) {
    const bus = this;
    const $rootScope = resolve("$rootScope");
    const $cart = $rootScope.$cart || {};
    bus.uploading = {};

    let promise = this.send(
      route,
      request,
      Object.assign({}, _config, {
        transformRequest: uploadTransform,
        headers: Object.assign(
          {
            "Content-Type": undefined, //'multipart/form-data',//false,
            "X-sse-subscription": eventListener.options.id,
            "X-cart-id": $cart.id,
          },
          DEFAULT_HEADERS,
          $appConfig.sessionId
            ? {
                "X-ss-pid": $appConfig.sessionId,
                "X-ss-opt": "perm",
              }
            : {}
        ),
        params: {},
      })
    );

    promise.then(
      (res) => console.log("upload success", res),
      (res) => console.error("upload failed", res),
      (progressEvent) => {
        console.warn("upload.notify", progressEvent);
        //console.info('upload.progressEvent', progressEvent);
        bus.uploading.last = progressEvent;
        bus.uploading.total = progressEvent.total;
        bus.uploading.loaded = progressEvent.loaded;
        bus.uploading.percentage = parseInt(
          (100.0 * progressEvent.loaded) / progressEvent.total
        );
      }
    );
    promise.finally(() => {
      bus.uploading = false;
    });

    return promise;
  }

  dispose() {
    const bus = this;
    //bus.channels.forEach(es=> es.close());
    //if (bus.options && bus.options.unRegisterUrl) {
    //$http.post(bus.options.unRegisterUrl, null);
    //}
  }

  validate(route, request, _config) {
    const bus = this;
    const $rootScope = resolve("$rootScope");
    const $cart = $rootScope.$cart || {};
    const config = Object.assign({}, _config, {
      headers: Object.assign(
        {
          "X-validate-only": true,
          "X-sse-subscription": eventListener.options.id,
          "X-cart-id": $cart.id,
        },
        DEFAULT_HEADERS,
        $appConfig.sessionId
          ? {
              "X-ss-pid": $appConfig.sessionId,
              "X-ss-opt": "perm",
            }
          : {}
      ),
    });
    return bus.send(route, request, config);
  }

  on() {
    return $rootScope.$on.apply(eventListener, arguments);
  }
  command() {
    return this.send.apply(this, arguments);
  }
  post() {
    return this.send.apply(this, arguments);
  }
  write() {
    return this.send.apply(this, arguments);
  }
  get() {
    return this.read.apply(this, arguments);
  }
  query() {
    return this.read.apply(this, arguments);
  }
  isBusy() {
    return this.activeCalls.length;
  }
}
